import { jsxs as s, Fragment as f, jsx as m } from "react/jsx-runtime";
import { Step as h } from "./Step.component.js";
import { useCallback as w } from "react";
import { FlowArrow as u } from "../flow-arrow/FlowArrow.component.js";
const x = ({
  index: o,
  step: r,
  onDelete: e,
  apiDeclaration: i,
  onAddNewStepAfter: t,
  copies: p,
  isLast: l,
  onEdit: n,
  theme: a
}) => {
  const c = w(() => {
    t(r, o);
  }, [o, t, r]);
  return /* @__PURE__ */ s(f, { children: [
    /* @__PURE__ */ m(
      h,
      {
        theme: a,
        step: r,
        onDelete: e,
        apiDeclaration: i,
        copies: p,
        onEdit: n
      }
    ),
    /* @__PURE__ */ m(u, { onClick: c, withButton: !l })
  ] });
};
export {
  x as StepWithArrow
};
